import ComingSoon from "@/components/ComingSoon";

export default function CompliancePage() {
  return <ComingSoon featureName="Compliance" description="Privilege elevation rules and compliance management. This feature requires backend Compliance APIs." />;
}
